import Mark from './Mark';
import Wordmark from './Wordmark';

/**
 * Footer — brand row + contact row. Two tel/mailto links so visitors can
 * reach out in whichever channel they prefer; the formatted phone is
 * visible, and the `tel:` href uses the E.164 form so iOS/Android dialers
 * pick it up cleanly. Tagline matches the hero (single warm sentence,
 * not the retired Transform/Elevate/Perform line).
 */
export default function Footer() {
  return (
    <footer>
      <div className="wrap">
        <div className="foot-brand">
          <span className="mark" aria-hidden="true">
            <Mark size={28} />
          </span>
          <span className="wordlock">
            <Wordmark width={150} className="wordmark wordmark-img" />
            <span className="brand-sub" aria-hidden="true">
              Design · Develop · Elevate
            </span>
          </span>
        </div>
        <div className="meta">
          <span className="tagline">Handmade websites for real-world businesses.</span>
        </div>
        <div className="meta">
          <a href="tel:+17038887050">(703)&nbsp;888-7050</a>
          <span aria-hidden="true"> · </span>
          <a href="mailto:hello@webnovaco.com">hello@webnovaco.com</a>
        </div>
        <div className="meta">© {new Date().getFullYear()} WebNova Studio</div>
      </div>
    </footer>
  );
}
